import { useCallback } from "react";
import useContent from "../../../hooks/useContent";

/**
 * Text for the X10 machine list. Contentful entries `outlets.x10devices_<key>` win; until they exist the English
 * fallback is shown. `%N%`-style placeholders are filled by the caller.
 */
const useDeviceListText = () => {
  const { outlets } = useContent();

  return useCallback(
    (key: string, fallback: string) => outlets?.[`x10devices_${key}`] || fallback,
    [outlets]
  );
};

export default useDeviceListText;
